import { Module } from 'vuex';
import socketio from 'socket.io-client';
import { RootState, ActionsKeys, RootGettersReturns } from '../types';
import {
  SocketState,
  SocketActionsPayload,
  SocketActionsKeys,
  SocketMutationsKeys,
  SocketMutationsPayload,
  responseCode,
} from '../types/socket';

export const socket = socketio(`${process.env.VUE_APP_API_URL}`, {
  autoConnect: false,
});

const initState = () => {
  const state: SocketState = {
    connected: false,
  };
  return state;
};

let connectionTimeout: number | NodeJS.Timeout;

const Sockets: Module<SocketState, RootState> = {
  state: {
    ...initState(),
  },
  actions: {
    [SocketActionsKeys.CONNECT_SOCKET]: ({ dispatch, rootGetters }) => {
      if (!socket.connected || socket.disconnected) {
        socket.io.opts.query = `token=${rootGetters.jwt}`;
        socket.connect();
        clearTimeout(connectionTimeout as number);
        connectionTimeout = setTimeout(() => {
          if ((rootGetters as RootGettersReturns).isLoggedIn) {
            dispatch(ActionsKeys.LOGOUT);
          }
        }, 5000);
      }
    },
    [SocketActionsKeys.DISCONNECT_SOCKET]: () => {
      socket.close();
    },
    [SocketActionsKeys.SOCKET_ON_CONNECT]: ({ commit }) => {
      commit(SocketMutationsKeys.SOCKET_CONNECTED);
      clearTimeout(connectionTimeout as number);
      // dispatch(SessionActionsKeys['JOIN_SESSION']);
    },
    [SocketActionsKeys.SOCKET_EMIT]: async ({ commit }, payload: SocketActionsPayload['SOCKET_EMIT']) => {
      const ack = new Promise((resolve, reject) => {
        socket.emit(payload.type, ...payload.params, ({ code, ...params }: { code: responseCode }) => {
          if (code === responseCode.SUCCESS) resolve(params);
          reject(params);
        });
        commit(SocketMutationsKeys.SOCKET_EMITTED, payload);
      });
      return ack;
    },
    [SocketActionsKeys.RESET_STATE]: ({ commit }) => {
      commit(SocketMutationsKeys.SOCKET_RESET_STATE);
    },
  },
  mutations: {
    [SocketMutationsKeys.SOCKET_CONNECTED]: state => {
      state.connected = true;
    },
    [SocketMutationsKeys.SOCKET_EMITTED]: () => null,
    [SocketMutationsKeys.SOCKET_MSG]: () => null,
    [SocketMutationsKeys.SOCKET_REGISTER_LISTENER]: (
      _state,
      payload: SocketMutationsPayload['SOCKET_REGISTER_LISTENER']
    ) => {
      socket.on(payload.key, payload.fn);
    },
    [SocketMutationsKeys.SOCKET_RESET_STATE]: state => {
      Object.assign(state, initState());
    },
  },
  getters: {},
};

export default Sockets;
